// hooks/useSubscription.ts
import { useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { getPortalUrl, getCheckoutUrl } from "../stripe/stripePayment";
import { usePremiumStatus } from "../context/PremiumStatusContext";
import app, { auth } from "../firebase/firebaseConfig";

const useSubscription = (productId: string) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [user] = useAuthState(auth);
  const { isSubscribedStripe } = usePremiumStatus();

  const handleSubscriptionAction = async () => {
    if (!user) {
      setError("You need to log in to subscribe.");
      return; // Stop the function if not logged in
    }

    setLoading(true);
    try {
      let redirectUrl = isSubscribedStripe
        ? await getPortalUrl(app)
        : await getCheckoutUrl(app, productId);
      if (redirectUrl) {
        window.location.href = redirectUrl;
      } else {
        throw new Error("No URL returned from Stripe");
      }
    } catch (error: any) {
      console.error("Error handling subscription action:", error);
      setError("Error processing subscription action");
    } finally {
      setLoading(false);
    }
  };

  return { loading, error, handleSubscriptionAction, isSubscribedStripe, user };
};

export default useSubscription;
